export enum PaymentMode {
  CASH = 1,
  CHEQUE = 2,
  ONLINE = 3,
}

export enum ChequeStatus {
  ISSUED = 1,
  REALIZED = 2,
  RETURNED = 3,
  CANCELLED = 4,
}
